import * as React from 'react';
import { CssVarsProvider, useColorScheme } from '@mui/joy/styles';
import GlobalStyles from '@mui/joy/GlobalStyles';
import CssBaseline from '@mui/joy/CssBaseline';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Checkbox from '@mui/joy/Checkbox';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel, { formLabelClasses } from '@mui/joy/FormLabel';
import IconButton, { IconButtonProps } from '@mui/joy/IconButton';
import Link from '@mui/joy/Link';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
// import GoogleIcon from './GoogleIcon';

interface FormElements extends HTMLFormControlsCollection {
    email: HTMLInputElement;
    password: HTMLInputElement;
    persistent: HTMLInputElement;
}
interface SignInFormElement extends HTMLFormElement {
    readonly elements: FormElements;
}

export default function ForgotPassword() {
    return (<>
        <Stack gap={2}>
            {/*  */}
            <Stack gap={1}>
            <Typography level="h3">Reset password</Typography>
                <Typography level="body-sm">
                    You will receive an email with instructions to reset your password.
                    {/*
                    {' '}
                    <Link level="title-sm" href="/login">
                        Back to Login
                    </Link>
                    */}
                </Typography>
            </Stack>

            <form
                onSubmit={(event: React.FormEvent<SignInFormElement>) => {
                    event.preventDefault();
                    const formElements = event.currentTarget.elements;
                    const data = {
                    email: formElements.email.value,
                    };
                    alert(JSON.stringify(data, null, 2));
                }}
            >
            <FormControl required>
                <FormLabel>Email</FormLabel>
                <Input type="email" name="email" />
            </FormControl>
            <Stack gap={4} sx={{ mt: 2 }}>
                <Button type="submit" fullWidth>
                Send Reset Email
                </Button>
            </Stack>
            </form>
        </Stack>
    </>);
}
